import React, { useState, useMemo, useCallback } from "react";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import data from "../../../../../assets/apiRoutes.json";
import {
    Column,
    DataGrid,
    LoadPanel as DataGridLoadPanel,
    Selection,
    Sorting,
    Paging,
    FilterRow,
} from "devextreme-react/data-grid";

function DetailTab(props) {
    const { formFields, accessToken } = props;
    const [selectedDetailId, setSelectedDetailId] = useState(null);

    const detailDataSource = useMemo(() => createStore({
        key: 'rowid',
        loadUrl: `${window._env_.REACT_APP_APIS}/${data.Transaction.GetTransactionDetails}`,
        loadParams: {
            transactionRowId: formFields.ROWID
        },
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`
            };
        },
    }), [formFields.ROWID, accessToken]);

    const locationDataSource = useMemo(() => {
        if (!selectedDetailId) return [];
        return createStore({
            key: 'rowid',
            loadUrl: `${window._env_.REACT_APP_APIS}/im/Transactionlocation/GetTransactionlocationDetails`,
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`,
                    Key: selectedDetailId,
                };
            },
        });
    }, [selectedDetailId, accessToken]);

    const onSelectionChanged = useCallback((e) => {
        const selectedKeys = e.selectedRowKeys;
        setSelectedDetailId(selectedKeys.length > 0 ? selectedKeys[0] : null);
    }, []);

    return (
        <div>
            <DataGrid
                dataSource={detailDataSource}
                showBorders={true}
                rowAlternationEnabled={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                height="20vh"
                onSelectionChanged={onSelectionChanged}
            >
                <DataGridLoadPanel enabled={true} />
                <Selection mode="single" />
                <Sorting mode="none" />
                <Paging enabled={false} />
                <FilterRow visible={true} />
                <Column dataField="itemCode" caption="Itemdd" allowSorting={false} allowEditing={false} />
                <Column dataField="itemDesc1" caption="Description" allowSorting={false} allowEditing={false} />
                <Column dataField="lotCode" caption="Lot" allowSorting={false} allowEditing={false} />
            </DataGrid>
            <br></br>
            <br></br>
            <br></br>
            <DataGrid
                dataSource={locationDataSource}
                showBorders={true}
                rowAlternationEnabled={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                height="20vh"
                style={{ marginTop: 10 }}
                noDataText={selectedDetailId ? "No data" : "Select a row above to view locations"}
            >
                <DataGridLoadPanel enabled={true} />
                <Selection mode="single" />
                <Sorting mode="none" />
                <Paging enabled={false} />
                <FilterRow visible={true} />
                <Column dataField="warehousecode" caption="Warehouse" allowSorting={false} allowEditing={false} />
                <Column dataField="locationcode" caption="Location" allowSorting={false} allowEditing={false} />
                <Column dataField="inReceiving" caption="In Receiving" dataType="number" format="#,##0.00" allowSorting={false} allowEditing={false} />
                <Column dataField="outShipped" caption="Out Shipped" dataType="number" format="#,##0.00" allowSorting={false} allowEditing={false} />
                <Column dataField="availableflagDiscription" caption="Available" allowSorting={false} allowEditing={false} />
            </DataGrid>
        </div>
    );
}

export default DetailTab;
